import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every pathname change, scroll the window back to the top.
 *
 * React Router preserves the previous scroll position on client-side
 * navigation, which lands users at the bottom of the page when they
 * came from a long page (Listing, Reels feed, Account, etc.). This
 * resets the scroll on every route change so each page opens fresh.
 *
 * Hash links (#section) are intentionally skipped so in-page anchors
 * still work as expected.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
